// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"label_inputLabel__hK8dM","inputLabelPadding":"label_inputLabelPadding__1KNtY","asteriskLabel":"label_asteriskLabel__3mMsb"};